<template>
  <div class="container">
    <div class="bg error">
      <img src="../../../assets/images/common/error.png" alt="出错了">
      <div class="text">啊呀，网络出小差了</div>
    </div>
    <div @click=refresh() class="btn refresh">刷新试一试</div>
  </div>
</template>

<script>
export default {
  name: "LoginError",
  data() {
    return {};
  },
  created() {},
  computed: {},
  mounted() {},
  methods: {
    refresh() {
      let info = null;
      if (this.$route.params && this.$route.params.info) {
        info = JSON.parse(this.$route.params);
        window.location.href = info.location;
      } else {
        // 刷新页面
        window.location.href = this.deleteAllUrlParam(window.location);
      }
    },

    // 删除所有参数
    deleteAllUrlParam(url) {
      let index = url.indexOf("?");
      if (index !== -1) return url.substr(0, index);
      return url;
    },
  },
};
</script>

<style scoped>
.container {
  height: 80vh;
  min-height: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.error img {
  width: 216px;
  height: 150px;
}

.error .text {
  margin-top: 15px;
  font-size: 14px;
  color: #999999;
  line-height: 20px;
}

.btn {
  margin-top: 26px;
  width: 190px;
  height: 44px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 25px;
  border: 1px solid #eaedf0;
  color: #ffffff;
  background: linear-gradient(90deg, #3871ff 0%, #2e5dd2 100%);
  line-height: 44px;
}
</style>
